import logo from './logo.svg';
import './App.css';
import { WebInConstruction } from './containers'
function App() {
  return (
    <div className="App">
      <WebInConstruction />
    </div>
  );
}

export default App;
